import { GzStorageProtectionIcapWebComponent } from './component/GzStorageProtectionIcapWebComponent';

export { GzStorageProtectionIcapWebComponent };
